import React from "react";
import { PageHeader } from "../../../components";

export default function SECRETARYGENERAL() {
  return (
    <div className="page-content">
      <PageHeader title="Management Details" page="management details" />
      {/* <!-- Content --> */}
      <div className="page-content">
        {/* <!-- Breadcrumb row END --> */}
        {/* <!-- contact --> */}
        <div className="content">
          {/* <!-- About Company --> */}
          <div className="section-fullbg-gray content-inner bg-gray ">
            <div className="container">
              <div className="row">
                <div className="col-md-5 col-sm-12 hidden-sm">
                  <img
                    src="./assets/images/members/LCC_SEC_GENERAL.jpg"
                    alt=""
                    className="m-b30"
                    width="440"
                  />
                </div>
                <div className="col-md-7 col-sm-12">
                  <h3 className="h3">OlUWATOYIN DEINDE </h3>
                  <div className="dlab-separator bg-primary"></div>
                  <h4 className="font-weight-3 00">
              Oluwatoyin Deinde is an accomplished IT and Customer Service professional with over 18 years of progressive experience in the telecommunications and banking sectors. Renowned for his leadership, strategic thinking, and problem-solving abilities, he has consistently delivered value through the implementation of innovative IT solutions and customer-centric initiatives.

He holds both a National Diploma and a Higher National Diploma in Computer Science from Yaba College of Technology, a Postgraduate Diploma in Computer Science from Lagos State University, and an MBA from the Metropolitan School of Business and Management, UK. In addition, he is professionally certified in ITIL, SAFe 4 Agilist, and Certified Agile Service Manager (CASM), demonstrating a strong foundation in IT service management and agile methodologies.

Oluwatoyin has also attended various local and international courses, earning additional certifications that have further enriched his professional capabilities.

His expertise lies in driving process transformation, digital optimization, and the efficient management of IT services in complex enterprise environments. He has successfully led and supported numerous technology-driven initiatives aimed at enhancing operational efficiency and improving customer experience.

A committed and long-standing member of Lagos Country Club since 2002, Oluwatoyin has an outstanding record of voluntary service, including the following roles:

Past Financial Secretary – Other Games Section

Past Entertainment Officer – Other Games Section

Member, Electoral Committee – At the Centre

Member, Bar & Catering Committee – At the Centre

Member, New Year Party Planning Committee


A results-oriented and service-driven individual, Oluwatoyin brings a unique blend of technical expertise, leadership, and collaborative spirit to every team and initiative he engages with. 
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- contact area  END --> */}
      </div>
    </div>
  );
}
